import { Nullable } from '@clearverify/types';

import { RevenueShareSetting, VerifierUpdate } from 'src/api';

export enum ChangeVerifierBillingFormFields {
  voe = 'voE',
  voi = 'voI',
  reverification = 'reverification',
}

export enum ChangeEmployerBillingFormFields {
  revenueShareValue = 'revenueShareValue',
  revenueShareType = 'revenueShareType',
}

export type VerifierBillingSettingsMutationDataType = Omit<VerifierUpdate, 'id'>;

export type RevenueShareSettingWithStripeStatuses = {
  id?: Nullable<string>;
  revenueShareSetting?: RevenueShareSetting | null | undefined;
  stripeStatus?: string;
};

export type RevenueShareSettingWithStripeStatusesList =
  Array<RevenueShareSettingWithStripeStatuses>;
